import {Component, HostBinding, Input} from '@angular/core';
import {getType} from '@angular/core/src/errors';
import {Item} from '@catmodules/widgets/breadcrumb/types';
import {MenuItem} from '@catui/types';
import {isNullOrUndefined} from 'util';

const componentBaseName = 'section-header';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-section-header',
  templateUrl: './section-header.component.html',
})
export class SectionHeaderComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() breadcrumbs: string[] = [];
  @Input() optionItems: MenuItem[] = [];

  get stickyOptionItems() {
    return this.optionItems.filter((item) => item.sticky);
  }

  get contextMenuOptionItems() {
    return this.optionItems.filter((item) => !item.sticky);
  }

  constructor() {
  }

  labelForItem(item: any) {
    let label = item;

    if (!isNullOrUndefined(item.label)) {
      label = item.label;
    }
    return label;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-base/components/section-header/section-header.component.ts